import React from "react";

import { css } from "glamor";
import { Spin, Form, Icon, Input, Button, Row, Col, Divider } from "antd";

const styles = {
    title: css({
        display: "block",
        textAlign: "center",
        fontSize: "22px",
        color: "#aaa",
        margin: "24px 0",
    }),
    lastFormItem: css({
        marginBottom: "0 !important",
    }),
    wrapper: css({
        background: "#FFF",
        borderRadius: "3px",
        boxShadow: "0 2px 10px 0 rgba(0, 0, 0, .2)",
        margin: "2rem !important",
        padding: "2rem !important",
        width: "500px !important",
    }),
    loginButton: css({ width: "100%" }),
    loginFooter: css({
        justifyContent: "space-between",
        marginTop: "72px",
        fontSize: "0.6em",
        color: "#999",
        alignItems: "center",
    }),
    copyright: css({
        marginTop: "5px",
    }),
    poweredBy: css({
        fontSize: "12px",
        textAlign: "right",
    }),
    arachnysLogo: css({
        backgroundRepeat: "no-repeat",
        backgroundSize: "100px 26px",
        backgroundPosition: "center",
        backgroundImage: `url(/static/img/logos/default.png)`,
        display: "inline-block",
        width: "100px",
        height: "18px",
        top: "5px",
        position: "relative",
        marginLeft: "0.5em",
    }),
    dividerText: css({
        fontSize: "12px",
        color: "#aaa",
    }),
    forgotPassword: css({
        textAlign: "center",
    }),
};

const ForgotPassword = () => (
    <div {...styles.forgotPassword}>
        <a href="/accounts/password_management/">Forgot password?</a>
    </div>
);

class LoginForm extends React.Component {
    handleSubmit = e => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err && this.props.onSubmit) {
                this.props.onSubmit(values);
            }
        });
    };

    primaryButton() {
        return (
            <Button
                {...styles.loginButton}
                data-at-id="login-button"
                type="primary"
                htmlType="submit"
            >
                Log In
            </Button>
        );
    }

    d3Button() {
        const { d3Text } = this.props;
        return (
            <Button
                {...styles.loginButton}
                href={`/allauth/accounts/kvasir/login/?next=${window.location.pathname}`}
                type="secondary"
            >
                {d3Text}
            </Button>
        );
    }

    buttonLayout() {
        if (this.props.stackButtons) {
            return (
                <React.Fragment>
                    <Row gutter={16}>
                        <Col span={24}>{this.primaryButton()}</Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <ForgotPassword />
                        </Col>
                    </Row>
                    <Divider>
                        <span {...styles.dividerText}>
                            or log in with Single Sign On
                        </span>
                    </Divider>
                    <Row gutter={16}>
                        <Col span={24}>{this.d3Button()}</Col>
                    </Row>
                </React.Fragment>
            );
        }
        return (
            <Row gutter={16}>
                <Col span={12}>{this.primaryButton()}</Col>
                <Col span={12}>{this.d3Button()}</Col>
            </Row>
        );
    }

    footer() {
        const { showPoweredBy } = this.props;
        return (
            <Row gutter={16}>
                <footer {...styles.loginFooter}>
                    <Col span={showPoweredBy ? 12 : 24} {...styles.copyright}>
                        &copy; 2019 Arachnys Information Systems Ltd.
                    </Col>
                    {showPoweredBy && (
                        <Col span={12} {...styles.poweredBy}>
                            Powered by
                            <span {...styles.arachnysLogo} />
                        </Col>
                    )}
                </footer>
            </Row>
        );
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { title } = this.props;
        return (
            <Spin spinning={this.props.isLoading} tip="Loading...">
                <Form {...styles.wrapper} onSubmit={this.handleSubmit}>
                    <Form.Item>
                        <span {...styles.title}>{title}</span>
                    </Form.Item>

                    {this.props.children && (
                        <Form.Item>{this.props.children}</Form.Item>
                    )}

                    <Form.Item>
                        {getFieldDecorator("username", {
                            rules: [
                                {
                                    required: true,
                                    message: "Please input your username",
                                },
                            ],
                        })(
                            <Input
                                data-at-id="username-input"
                                prefix={<Icon type="user" />}
                                type="text"
                                placeholder="Username"
                            />
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator("password", {
                            rules: [
                                {
                                    required: true,
                                    message: "Please input your password",
                                },
                            ],
                        })(
                            <Input
                                data-at-id="password-input"
                                prefix={<Icon type="lock" />}
                                type="password"
                                placeholder="Password"
                            />
                        )}
                    </Form.Item>
                    <i>
                        Enter the 6-digit code generated by the authenticator
                        application. Required if your account has two-factor
                        authentication enabled.
                    </i>
                    <Form.Item>
                        {getFieldDecorator("token", {
                            rules: [
                                {
                                    message: "Please input your token",
                                },
                            ],
                        })(
                            <Input
                                prefix={<Icon type="safety" />}
                                type="text"
                                placeholder="Authentication Code"
                            />
                        )}
                    </Form.Item>
                    <Form.Item>{this.buttonLayout()}</Form.Item>
                    {this.footer()}
                </Form>
            </Spin>
        );
    }
}

LoginForm.defaultProps = {
    title: "",
    showPoweredBy: false,
    d3Text: "Log In with Navigator",
    stackButtons: false,
};
export default Form.create()(LoginForm);
